import React, { useState } from "react";
// redux
import { connect } from "react-redux";

// icons
import { AiOutlineLock } from "react-icons/ai";

// react router
import { useHistory } from "react-router-dom";

// bootstrap
import {
	Spinner
} from "react-bootstrap";

// styles
import {
	CartContainer,
	Heading,
	PagingLink,
	ProductListSession
} from "../../styles/Body";

// react toastify
import { toast } from "react-toastify";

// APIs | cart
import {
	getCartItems,
	deleteCartItem,
	saveToCart,
	checkCoupon,
	removeCoupon
} from "utlis/Apis/Cart_API";

// actions
import {
	setCartItem,
	setCartDetails,
	setCartImages,
} from "redux/actions/actionCart";

// app messages
import {
	ERROR_WHILE__NAME,
	UNKNOWN_ERROR_OCCURED,
	DELETED_FROM_CART_SUCCESSFULLY,
	ERROR_WHILE_DELETING_PRODUCT_TO_CART,
	UPDATED_TO_CART_SUCCESSFULLY,
	ERROR_WHILE_SAVING_PRODUCT_TO_CART,
} from "utlis/AppMessages/AppMessages";

import RightCheckoutBar from "./RightCheckoutBar";

// cart item
import CartListSec from "./CartListSec";

function Body(props) {
	// props
	const {
		pageLoading,
		currentUser,
		tempOrderId,

		commonToken,

		setCartItem,
		setCartImages,
		setCartDetails,

		cartItems,
		cartImages,
		cartDetails,

	} = props;

	// consts
	const quantitySelector = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40]
	const history = useHistory();

	// states
	const [cartLoading, setCartLoading] = useState(false);
	const [existingEmail, setExistingEmail] = useState(false);
	const [rightMenuVisibility, setRightMenuVisibility] = useState(false);
	const [pageCoupon, setPageCoupon] = useState("");
	const [pageCouponBtnLoading, setPageCouponBtnLoading] = useState(false);
	const [pageCouponBtnDisabled, setPageCouponBtnDisabled] = useState(false);
	const [rightBarLoading, setRightBarLoading] = useState(false);

	const [btnLoading, setBtnLoading] = useState(false);
	const [btnDisabled, setBtnDisabled] = useState(false);

	// handle delete cart item
	const handleDelete = (ev, item) => {
		ev.preventDefault();

		if (item) {
			const userConfirmation = window.confirm("Are you sure you want to delete this item from the cart?")
			if (userConfirmation) {
				// enable loading
				setCartLoading(true);

				// deleting cart data
				deleteCartItem(currentUser?.userToken ?? "", item).then((res) => {
					const resData = res.data;

					// disabling loading
					setCartLoading(false);

					// if request succesfull
					if (resData && resData.success) {

						const cartData = resData.data;
						// saving items to global store
						setCartItem(cartData.content);
						setCartImages(cartData.images);
						setCartDetails({
							cart_discount: cartData.cart_discount,
							cart_items: cartData.cart_items,
							cart_qty: cartData.cart_qty,
							cart_sub_total: cartData.cart_sub_total,
							cart_total: cartData.cart_total,
							coupon_code: cartData.coupon_code,
							coupon_value: cartData.coupon_value,
							allCartData: cartData
						});

						// dismissing all the previous toasts first
						toast.dismiss();

						// showing the error message
						toast.success(DELETED_FROM_CART_SUCCESSFULLY, {
							autoClose: 2500,
							onClose: () => { },
						});
					}

					// if request is not succesfull
					if (resData && resData.error) {
						// dismissing all the previous toasts first
						toast.dismiss();

						// showing the error message
						toast.error(ERROR_WHILE_DELETING_PRODUCT_TO_CART, {
							autoClose: 3000,
							onClose: () => { },
						});
					}
				}).catch((err) => {
					console.log(`${ERROR_WHILE__NAME} deleteCartItem `, err.message);

					// dismissing all the previous toasts first
					toast.dismiss();

					// showing the error message
					toast.error(UNKNOWN_ERROR_OCCURED, {
						autoClose: 3000,
						onClose: () => {
							// disabling loading
							setCartLoading(false);
						},
					});
				});
			}
		}
	};

	// const handleQuantityChange = (ev, item) => {
	// 	const value = ev.target.value
	// 	if (item && value) {
	// 		handleUpdate(value, item)
	// 	}
	// }

	// handle delete cart item
	const handleUpdate = (quantity, item) => {
		// enable loading
		setCartLoading(true);

		if (item) {
			const cartItemToSave = {
				customer_id: currentUser?.userId ?? "",
				mode: "update",
				product_id: item.product_id,
				quantity,
				temp_order_id: tempOrderId,
				variant_sku: item.variant_sku,
			};

			// getting data
			saveToCart(currentUser?.userToken ?? "", cartItemToSave).then((res) => {
				const resData = res.data;

				// if request succesfull
				if (resData && resData.success) {
					const cartData = resData.data;

					// saving items to global store
					setCartItem(cartData?.content);
					setCartImages(cartData.images);
					setCartDetails({
						cart_discount: cartData.cart_discount,
						cart_items: cartData.cart_items,
						cart_qty: cartData.cart_qty,
						cart_sub_total: cartData.cart_sub_total,
						cart_total: cartData.cart_total,
						coupon_code: cartData.coupon_code,
						coupon_value: cartData.coupon_value,
						allCartData: cartData
					});

					// dismissing all the previous toasts first
					toast.dismiss();

					// showing the error message
					toast.success(UPDATED_TO_CART_SUCCESSFULLY, {
						autoClose: 3000,
						onClose: () => { },
					});
				}

				// if request is not succesfull
				if (resData && resData.error) {
					// dismissing all the previous toasts first
					toast.dismiss();

					// showing the error message
					toast.error(resData?.message || ERROR_WHILE_SAVING_PRODUCT_TO_CART, {
						autoClose: 3000,
						onClose: () => { },
					});
				}

				/// disable loading
				setCartLoading(false);
			}).catch((err) => {
				console.log(`${ERROR_WHILE__NAME} saveToCart `, err.message);

				// dismissing all the previous toasts first
				toast.dismiss();

				// showing the error message
				toast.error(UNKNOWN_ERROR_OCCURED, {
					autoClose: 3000,
					onClose: () => {
						/// disable loading
						setCartLoading(false);
					},
				});
			});
		}
	};

	const handleCheckoutBtnClick = ev => {
		ev.preventDefault()

		if (!currentUser) { // if there's no user currently logged in, then open the right menu
			setRightMenuVisibility(true)
		} else { // moving to checkout if no user is logged in
			history.push({
				pathname: "/checkout",
				state: {
					allowNavigation: true
				}
			})
		}
	}

	// coupon value change
	const handleCouponValueChange = (ev) => {
		const inpVal = ev.target.value
		if (inpVal) {
			setPageCoupon(inpVal)
		} else {
			setPageCoupon("")
		}
	}

	// apply coupon click
	const handleApplyCouponClick = (ev) => {
		ev.preventDefault()

		if (pageCoupon?.length) {
			// button loading
			setPageCouponBtnLoading(true)
			setPageCouponBtnDisabled(true)

			const requiredData = {
				tempOrderId,
				couponCode: pageCoupon,
				customerId: currentUser?.userId ?? '',
			}

			checkCoupon(commonToken ?? "", requiredData).then(res => {
				const resData = res.data

				// if success
				if (resData?.success) {

					// getting cart items from the database
					getCartItems(currentUser?.userToken ?? "", tempOrderId).then(res => {
						// button loading
						setPageCouponBtnLoading(false)
						setPageCouponBtnDisabled(false)

						const resData = res.data;

						// if request succesfull
						if (resData && resData.success) {
							const cartData = resData.data;

							// saving items to global store
							setCartItem(cartData.content);
							setCartImages(cartData.images);
							setCartDetails({
								cart_discount: cartData.cart_discount,
								cart_items: cartData.cart_items,
								cart_qty: cartData.cart_qty,
								cart_sub_total: cartData.cart_sub_total,
								cart_total: cartData.cart_total,
								coupon_code: cartData.coupon_code,
								coupon_value: cartData.coupon_value,
								allCartData: cartData
							});

							// dismissing all the previous toasts first
							toast.dismiss();

							// showing the error message
							toast.success("Coupon applied successfully", {
								autoClose: 2500,
								onClose: () => { },
							});
						}

						// if request is not succesfull
						if (resData && resData.error) {

							// dismissing all the previous toasts first
							toast.dismiss();

							// showing the error message
							toast.error(resData?.message || "Unknown error occured", {
								autoClose: 2500,
								onClose: () => { },
							});
						}
					}).catch((err) => {
						console.log(`${ERROR_WHILE__NAME} getCartItems `, err.message);

						// dismissing all the previous toasts first
						toast.dismiss();

						// showing the error message
						toast.error(UNKNOWN_ERROR_OCCURED, {
							autoClose: 2500,
							onClose: () => {
								// button loading
								setPageCouponBtnLoading(false)
								setPageCouponBtnDisabled(false)
							},
						});
					})

				}

				// if error
				if (resData?.error) {
					// dismissing all the previous toasts first
					toast.dismiss();

					// showing the error message
					toast.error(resData?.message || "invalid coupon", {
						autoClose: 2500,
						onClose: () => {
							// button loading
							setPageCouponBtnLoading(false)
							setPageCouponBtnDisabled(false)
						},
					});

				}
			}).catch(err => {
				console.log(`${ERROR_WHILE__NAME} checkCoupon `, err.message);

				// dismissing all the previous toasts first
				toast.dismiss();

				// showing the error message
				toast.error(UNKNOWN_ERROR_OCCURED, {
					autoClose: 2500,
					onClose: () => {
						// button loading
						setPageCouponBtnLoading(false)
						setPageCouponBtnDisabled(false)
					},
				});
			})
		}
	}

	// remove coupon click
	const handleRemoveCouponClick = (ev) => {
		ev.preventDefault()
		// loading
		setRightBarLoading(true)

		removeCoupon(commonToken ?? "", tempOrderId).then(res => {
			const resData = res.data

			// if success
			if (resData?.success) {

				// getting cart items from the database
				getCartItems(commonToken ?? "", tempOrderId).then(res => {
					// loading
					setRightBarLoading(false)

					const resData = res.data;

					// if request succesfull
					if (resData && resData.success) {
						const cartData = resData.data;

						// saving items to global store
						setCartItem(cartData.content);
						setCartImages(cartData.images);
						setCartDetails({
							cart_discount: cartData.cart_discount,
							cart_items: cartData.cart_items,
							cart_qty: cartData.cart_qty,
							cart_sub_total: cartData.cart_sub_total,
							cart_total: cartData.cart_total,
							coupon_code: cartData.coupon_code,
							coupon_value: cartData.coupon_value,
							allCartData: cartData
						});

						// dismissing all the previous toasts first
						toast.dismiss();

						// showing the error message
						toast.success("Coupon removed successfully", {
							autoClose: 2500,
							onClose: () => { },
						});
					}

					// if request is not succesfull
					if (resData && resData.error) {

						// dismissing all the previous toasts first
						toast.dismiss();

						// showing the error message
						toast.error(resData?.message || "Unknown error occured", {
							autoClose: 2500,
							onClose: () => { },
						});
					}
				}).catch((err) => {
					console.log(`${ERROR_WHILE__NAME} getCartItems `, err.message);

					// dismissing all the previous toasts first
					toast.dismiss();

					// showing the error message
					toast.error(UNKNOWN_ERROR_OCCURED, {
						autoClose: 2500,
						onClose: () => {
							// loading
							setRightBarLoading(false)
						},
					});
				})

			}

			// if error
			if (resData?.error) {
				// dismissing all the previous toasts first
				toast.dismiss();

				// showing the error message
				toast.error(resData?.message || "Unknown Error", {
					autoClose: 2500,
					onClose: () => {
						// loading
						setRightBarLoading(false)
					},
				});

			}
		}).catch(err => {
			console.log(`${ERROR_WHILE__NAME} removeCoupon `, err.message);

			// dismissing all the previous toasts first
			toast.dismiss();

			// showing the error message
			toast.error(UNKNOWN_ERROR_OCCURED, {
				autoClose: 2500,
				onClose: () => {
					// loading
					setRightBarLoading(false)
				},
			});
		})
	}

	return (
		<CartContainer className="position-relative">
			{/* <div className="row g-5 px-2"> */}
			<div className="d-lg-flex flex-wrap align-items-start cart-container-main px-lg-2">
				{/* left part */}
				<div className="lt-sec-main media-body">
					<div className="inner position-relative">
						<div className="pb-3">
							<Heading>Shopping Cart ({cartDetails?.cart_qty ?? 0})</Heading>
							<PagingLink>
								<span>Store</span> &ensp;/&ensp;<span>Shopping Cart</span>
							</PagingLink>
						</div>
						{/* product list with details */}
						<ProductListSession>
							<div className="mb-3">
								<div className="list-main position-relative">
									<div className="list-main-inner">
										<div className="table-responsive">
											<table className="table">
												<tbody>
													{
														cartItems?.length ? cartItems.map((item, index) => {
															return (
																<CartListSec
																	key={item.product_id + index}

																	dataItem={item}

																	cartImages={cartImages}

																	handleUpdate={(quantity, item) => handleUpdate(quantity, item)}
																	handleDelete={(ev, item) => handleDelete(ev, item)}
																/>
															)
														}) : null
													}
												</tbody>
											</table>
										</div>
									</div>

									{
										/* loading */
										cartLoading ? (
											<div className="cart-loading position-absolute d-flex justify-content-center align-items-center">
												<Spinner animation="border" />
											</div>
										) : null
									}
								</div>
							</div>
						</ProductListSession>
					</div>
				</div>

				<div className="rt-sec-main">
					<div className="inner position-relative">
						{/* head */}
						<div className="header-part mb-3">
							<p className="d-flex align-items-center st-fs-17 st-fw-600 mb-0">
								<AiOutlineLock className="position-relative" style={{ top: -1 }} />
								<span className="ms-2">Cart Summary</span>
							</p>
						</div>

						<div className="content">
							{
								cartItems?.length ? (
									<React.Fragment>
										{/* frac */}
										<div className="frac d-flex st-fs-15 mb-2">
											<div className="lt">
												<p className="mb-0 text-capitalize">
													sub total
												</p>
											</div>
											<div className="rt ps-2 ms-auto">
												<p className="mb-0 st-fw-800">
													{cartDetails?.cart_sub_total}
												</p>
											</div>
										</div>

										{/* frac */}
										<div className="frac d-flex st-fs-15 mb-2">
											<div className="lt">
												<p className="mb-0 text-capitalize">
													discount
												</p>
											</div>
											<div className="rt ps-2 ms-auto">
												<p className="mb-0 st-fw-800 text-danger">
													{cartDetails?.cart_discount}
												</p>
											</div>
										</div>

										{/* frac */}
										<div className="frac d-flex st-fs-15 mb-2">
											<div className="lt">
												<p className="mb-0 text-capitalize">
													Shipping
												</p>
											</div>
											<div className="rt ps-2 ms-auto">
												<p className="mb-0 st-fw-800">
													{cartDetails?.allCartData?.shipping_amount_currency ?? "$0.00"}
												</p>
											</div>
										</div>

										{/* frac */}
										<div className="frac d-flex st-fs-15 mb-2">
											<div className="lt">
												<p className="mb-0 text-capitalize">
													estimated tax
												</p>
											</div>
											<div className="rt ps-2 ms-auto">
												<p className="mb-0 st-fw-800">
													{cartDetails?.cart_tax ?? "$0.00"}
												</p>
											</div>
										</div>

										{/* frac */}
										<div className="frac d-flex mb-2 main-total border-top pt-3 mt-4 mb-4 st-fs-17">
											<div className="lt">
												<p className="mb-0 st-fw-800 text-capitalize">
													Total
												</p>
											</div>
											<div className="rt ps-2 ms-auto">
												<p className="mb-0 st-fw-800">
													{cartDetails?.cart_total}
												</p>
											</div>
										</div>

										<div className="promo-code">
											{
												cartDetails?.coupon_code ? (
													<React.Fragment>
														<div className="header mb-2">
															<p className="head st-fw-800 st-fs-15 mb-1">Coupon Applied</p>
														</div>
														<div className="form d-flex">
															<span className="st-fw-600">{cartDetails.coupon_code}</span>
															<span className="text-primary cursor-pointer hover-underline-link ms-2" onClick={handleRemoveCouponClick}>remove</span>
														</div>
													</React.Fragment>
												) : (
													<React.Fragment>
														<div className="header mb-2">
															<p className="head st-fw-800 st-fs-15 mb-1">Apply a Promo Code</p>
															<p className="desc st-fs-13 st-line-height-normal">Remove any spaces or dashes before hitting apply.</p>
														</div>
														<div className="form d-flex">
															<input
																type="text"
																className="form-control media-body rounded-0"
																defaultValue={pageCoupon}
																onChange={handleCouponValueChange}
															/>
															<button
																className="btn ms-2 rounded-0 st-fw-600 text-uppercase"
																style={{ width: 68 }}
																disabled={pageCouponBtnDisabled}
																onClick={handleApplyCouponClick}>
																{
																	pageCouponBtnLoading ? (
																		<Spinner animation="border" size="sm" />
																	) : (
																		<span>Apply</span>
																	)
																}
															</button>
														</div>
													</React.Fragment>
												)
											}
										</div>

										<div className="btns">
											<button
												className="btn rounded-0 btn-block text-uppercase st-fw-800 default-btn"
												disabled={btnDisabled}
												onClick={handleCheckoutBtnClick}>
												{
													btnLoading ? (
														<Spinner animation="border" />
													) : (
														<span>Checkout now</span>
													)
												}
											</button>
											<p className="mt-2 st-fs-13 mb-0">
												By continuing to Checkout, you are agreeing to our <a href="/content/terms" className="text-decoration-underline">Terms of Use</a> and <a href="/content/privacy-policy" className="text-decoration-underline">Privacy Policy</a>.
											</p>
										</div>
									</React.Fragment>
								) : (
									<React.Fragment>
										{
											!cartLoading ? (
												<p className="st-fs-17 mb-0">
													No items in the cart
												</p>
											) : null
										}
									</React.Fragment>
								)
							}

						</div>


						{
							// loading
							rightBarLoading ? (
								<div className="cart-loading position-absolute d-flex justify-content-center align-items-center" >
									<Spinner animation="border" />
								</div>
							) : null
						}
					</div>

				</div>
			</div>

			{
				pageLoading ? (
					<div className="cart-loading position-absolute d-flex justify-content-center align-items-center" >
						<Spinner animation="border" />
					</div>
				) : null
			}

			<RightCheckoutBar
				isActive={rightMenuVisibility}
				setRightMenuVisibility={setRightMenuVisibility}

				existingEmail={existingEmail}
				setExistingEmail={setExistingEmail}
			/>
		</CartContainer>
	);
}

const getDataFromStore = (state) => {
	return {
		cartItems: state.cart.cartItems,
		cartImages: state.cart.cartImages,
		cartDetails: state.cart.cartDetails,
		currentUser: state.auth.currentUser,
		commonToken: state.auth.commonToken,
		tempOrderId: state.auth.tempOrderId,
	};
};

const dispatchActionsToProps = (dispatch) => {
	return {
		setCartItem: (bool) => dispatch(setCartItem(bool)),
		setCartImages: cartData => dispatch(setCartImages(cartData)),
		setCartDetails: (bool) => dispatch(setCartDetails(bool)),
	};
};

export default connect(getDataFromStore, dispatchActionsToProps)(Body);